import { actionTypes } from "./actions";

const initialState = {
  data: null,
  loading: false,
  error: null
};

export default function skipTraceReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SKIP_TRACE_POST_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }

    case actionTypes.SKIP_TRACE_POST_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload
      };
    }

    case actionTypes.SKIP_TRACE_POST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }

    default:
      return state;
  }
}
